import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_administradores/Administracion_administradores.html?vue&type=template&id=6271dfa7&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_administradores/Administracion_administradores.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_administradores/Administracion_administradores.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_administradores/Administracion_administradores.css?vue&type=style&index=0&id=6271dfa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271dfa7",
  null
  
)

export default component.exports